
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.952.8c6.176 0 11.2 5.024 11.2 11.2 0 6.176-5.024 11.2-11.2 11.2-6.176 0-11.2-5.024-11.2-11.2C.752 5.824 5.776.8 11.952.8zm0 1.4c-5.403 0-9.8 4.396-9.8 9.8 0 5.403 4.397 9.8 9.8 9.8 5.403 0 9.8-4.397 9.8-9.8 0-5.404-4.397-9.8-9.8-9.8zm-.2 13.292c.299 0 .547.1.744.304.197.202.296.448.296.736 0 .287-.099.533-.296.735a.993.993 0 01-.744.304.998.998 0 01-.735-.304 1 1 0 01-.305-.735c0-.288.102-.534.305-.736a.994.994 0 01.735-.304zm.24-9.504c.949 0 1.763.267 2.441.8.676.533 1.015 1.275 1.015 2.224 0 .446-.102.866-.307 1.26a3.898 3.898 0 01-.743 1.011l-.863.84c-.286.28-.53.587-.73.924-.2.337-.301.694-.301 1.07h-1.487c0-.47.1-.908.303-1.313.203-.405.451-.749.744-1.03l.861-.827c.282-.269.524-.56.729-.876.204-.313.306-.646.306-.998 0-.532-.184-.94-.552-1.222-.368-.282-.845-.423-1.431-.423-1.174 0-1.926.517-2.256 1.552l-1.265-.704c.267-.747.721-1.315 1.36-1.705.64-.389 1.366-.583 2.176-.583z"}})])
          )
        }
      }
    